import { EventEnvelop } from './event-envelop';

export class JsonEventSerializer {
    static serializeEvent<T>(event: EventEnvelop | Array<EventEnvelop>): string {
        if (event instanceof Array) {
            event = event.map(JsonEventSerializer.inferTypeInformation);
        } else {
            event = JsonEventSerializer.inferTypeInformation(event);
        }
        return JSON.stringify(event);
    }


    /**
     * metodo di utility per inserire il tipo se utilizziamo dei binder lato server
     * @param event
     */
    static inferTypeInformation(event: EventEnvelop) {
        // if (event.eventType) {
        //     let tmp = (event as any);
        //     // tmp.$type = e.eventType[0].toUpperCase() + e.eventType.substring(1);
        //     // tmp.data.$type = e.eventType[0].toUpperCase() + e.eventType.substring(1);
        //     return tmp as EventEnvelop;
        // }
        return event;
    }
}
